import React from 'react';
import { Typography, Box, Stack, Paper } from '@mui/material';
import profile from '../profileData';

const Awards = () => (
  <Box id="awards" sx={{ py: { xs: 3, md: 5 }, px: { xs: 1, md: 0 }, maxWidth: { xs: '100%', md: 1200 }, mx: 'auto' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Box sx={{ width: 4, height: 32, bgcolor: 'primary.main', mr: 2, borderRadius: 2 }} />
      <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: 1, fontSize: { xs: 24, md: 32 } }}>
        Honors, Awards, and Grants
      </Typography>
    </Box>
    <Stack spacing={3} mt={2}>
      {profile.awards.map((award, idx) => (
        <Paper 
          key={idx} 
          elevation={1}
            sx={{ 
            p: 2.5, 
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
              transform: 'translateY(-4px)',
              borderColor: 'primary.main',
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Typography variant="h6" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 18, md: 20 } }}>
              {award.title}
            </Typography>
            <Typography variant="h6" sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 18, md: 20 }, color: 'text.secondary' }}>
              , {award.organization}
            </Typography>
            <Typography variant="h6" sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 18, md: 20 }, color: 'text.secondary', fontStyle: 'italic' }}>
              ({award.year})
            </Typography>
          </Box>
          {award.description && (
            <Typography variant="body1" sx={{ mt: 1, fontSize: { xs: 14, md: 16 } }}>
              {award.description}
            </Typography>
          )}
        </Paper>
      ))}
    </Stack>
  </Box>
);

export default Awards; 